module.exports = __webpack_public_path__ + "img/bx-qapaper-publish-active.8fcdf963.svg";